export default __webpack_public_path__ + "static/media/boxes-odd-green.f19def56.svg";